export default {
    path: 'activeData',
    component: () => import('@/pages/dataAnalysis/activeData'),
}